// extracted by css-extract-rspack-plugin
export default {"tooltipContent":"RwtjRM562I469FMB"};